"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var common_1 = require("docs/common");
var components_1 = require("components");
var componentStyle = {
    base: {
        height: 350,
    },
};
var description = 'You can use the <code class="inline">iconName</code> ' +
    'and <code class="inline">text</code> properties to pass content do Drawer Item.';
var code = "import React from 'react';\nimport { Drawer, DrawerItem } from c-react-ui';\n\nconst style = {\n  height: 350,\n};\n\nconst DrawerItemExample = () => (\n  <Drawer style={style}>\n    <DrawerItem iconName=\"file\" text=\"File\" />\n    <DrawerItem iconName=\"list\" text=\"Todos\" />\n  </Drawer>\n)";
exports.ContentExampleDrawerItem = function (props) { return (React.createElement(common_1.Example, { title: "Content", description: description, code: code },
    React.createElement(components_1.Drawer, { style: componentStyle.base },
        React.createElement(components_1.DrawerItem, { iconName: "file", text: "File" }),
        React.createElement(components_1.DrawerItem, { iconName: "list", text: "Todos" })))); };
exports.ContentExampleDrawerItem.displayName = 'ContentExampleDrawerItem';



//////////////////
// WEBPACK FOOTER
// ./src/docs/pages/ComponentDrawerItemPage/ContentExampleDrawerItem.tsx
// module id = 656
// module chunks = 0